var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("vue-custom-scrollbar", [
    _c("div", { staticClass: "ap-modal-element" }, [
      _c("div", { staticClass: "ap-modal-input-name" }, [
        _vm._v("\n                Тип продукта "),
        _c("span", { staticClass: "red-text" }, [_vm._v("*")])
      ]),
      _vm._v(" "),
      _c(
        "select",
        {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.type,
              expression: "type"
            }
          ],
          staticClass: "cd-modal-text-input",
          on: {
            change: function($event) {
              var $$selectedVal = Array.prototype.filter
                .call($event.target.options, function(o) {
                  return o.selected
                })
                .map(function(o) {
                  var val = "_value" in o ? o._value : o.value
                  return val
                })
              _vm.type = $event.target.multiple
                ? $$selectedVal
                : $$selectedVal[0]
            }
          }
        },
        [
          _c("option", { attrs: { disabled: "", selected: "", value: "" } }, [
            _vm._v("- Не выбрано -")
          ]),
          _vm._v(" "),
          _c("option", { attrs: { value: "wall" } }, [_vm._v("Фасад")]),
          _vm._v(" "),
          _c("option", { attrs: { value: "additional" } }, [
            _vm._v("Доборный элемент")
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showAlert === "type",
              expression: "showAlert === 'type'"
            }
          ],
          staticClass: "form-alert-danger"
        },
        [_vm._v("\n                Обязательное поле!\n            ")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.type,
              expression: "!type"
            }
          ],
          staticClass: "margin-20-0"
        },
        [
          _c("i", [
            _vm._v(
              "Сперва укажите тип продукта, который Вы бы хотели добавить."
            )
          ])
        ]
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.type,
            expression: "type"
          }
        ],
        staticClass: "ap-product-modal-grid"
      },
      [
        _c("div", [
          _c("div", { staticClass: "ap-modal-element" }, [
            _c("div", { staticClass: "ap-modal-input-name" }, [
              _vm._v("\n                        Название продукта "),
              _c("span", { staticClass: "red-text" }, [_vm._v("*")])
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.name,
                  expression: "name"
                }
              ],
              staticClass: "cd-modal-text-input",
              attrs: { type: "text" },
              domProps: { value: _vm.name },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.name = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showAlert === "name",
                    expression: "showAlert === 'name'"
                  }
                ],
                staticClass: "form-alert-danger"
              },
              [
                _vm._v(
                  "\n                        Обязательное поле!\n                    "
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "ap-modal-input-name" }, [
              _vm._v("\n                        Артикул "),
              _c("span", { staticClass: "red-text" }, [_vm._v("*")])
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.vendorCode,
                  expression: "vendorCode"
                }
              ],
              staticClass: "cd-modal-text-input",
              attrs: { type: "text" },
              domProps: { value: _vm.vendorCode },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.vendorCode = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showAlert === "vendor_code",
                    expression: "showAlert === 'vendor_code'"
                  }
                ],
                staticClass: "form-alert-danger"
              },
              [
                _vm._v(
                  "\n                        Обязательное поле!\n                    "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "ap-modal-title-medium" }, [
            _vm._v("\n                    Параметры текстуры\n                ")
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.type === "wall",
                  expression: "type === 'wall'"
                }
              ],
              staticClass: "ap-modal-element"
            },
            [
              _c("div", { staticClass: "ap-modal-input-name" }, [
                _vm._v(
                  "\n                        Высота текстуры, м (не более 15)\n                    "
                )
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.textureHeight,
                    expression: "textureHeight"
                  }
                ],
                staticClass: "cd-modal-text-input",
                attrs: { type: "number", min: "0", max: "15", step: "0.1" },
                domProps: { value: _vm.textureHeight },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.textureHeight = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showDimensionsAlert === "textureHeight",
                      expression: "showDimensionsAlert === 'textureHeight'"
                    }
                  ],
                  staticClass: "form-alert-danger"
                },
                [
                  _vm._v(
                    "\n                        Недопустимо высокое значение!\n                    "
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "ap-modal-element" }, [
            _c("div", { staticClass: "ap-modal-input-name" }, [
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.type === "wall",
                      expression: "type === 'wall'"
                    }
                  ]
                },
                [_vm._v("Ширина текстуры, м (не более 15)")]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.type !== "wall",
                      expression: "type !== 'wall'"
                    }
                  ]
                },
                [_vm._v("Ширина продукта, м (не более 15)")]
              )
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.textureWidth,
                  expression: "textureWidth"
                }
              ],
              staticClass: "cd-modal-text-input",
              attrs: { type: "number", min: "0", max: "15", step: "0.1" },
              domProps: { value: _vm.textureWidth },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.textureWidth = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showDimensionsAlert === "textureWidth",
                    expression: "showDimensionsAlert === 'textureWidth'"
                  }
                ],
                staticClass: "form-alert-danger"
              },
              [
                _vm._v(
                  "\n                        Недопустимо высокое значение!\n                    "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "ap-modal-element" },
            [
              _c("div", { staticClass: "ap-modal-input-name" }, [
                _vm._v("\n                        Цвет\n                    ")
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "custom-select-grid",
                  on: {
                    click: function($event) {
                      _vm.showColorDropdown = !_vm.showColorDropdown
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "cd-modal-text-input custom-select" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "custom-select-color-circle-border",
                          class: { "color-border": _vm.color_id !== "" }
                        },
                        [
                          _c("div", {
                            staticClass: "custom-select-color-circle",
                            style: { "background-color": _vm.colorDataByID.hex }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(
                          "\n                                " +
                            _vm._s(_vm.colorDataByID.name) +
                            "\n                            "
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("SVGPallet", { staticClass: "custom-select-switch" })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "vue-custom-scrollbar",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showColorDropdown,
                      expression: "showColorDropdown"
                    }
                  ],
                  staticClass: "custom-select-dropdown"
                },
                _vm._l(_vm.optionsColors, function(option) {
                  return _c(
                    "div",
                    {
                      staticClass: "custom-select-option",
                      on: {
                        click: function($event) {
                          return _vm.selectColor(option.id)
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "custom-select-color-circle-border",
                          staticStyle: { "border-color": "#929292" }
                        },
                        [
                          _c("div", {
                            staticClass: "custom-select-color-circle",
                            style: { "background-color": option.hex }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(
                          "\n                                " +
                            _vm._s(option.name) +
                            "\n                            "
                        )
                      ])
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showAlert === "color_id",
                      expression: "showAlert === 'color_id'"
                    }
                  ],
                  staticClass: "form-alert-danger"
                },
                [
                  _vm._v(
                    "\n                        Обязательное поле!\n                    "
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "ap-modal-title-medium" }, [
            _vm._v("\n                    Категория продукта "),
            _c("span", { staticClass: "red-text" }, [_vm._v("*")])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "ap-button-edit-category ap-modal-element",
              on: { click: _vm.selectCategory }
            },
            [
              _c("SVGAdminEditRow", {
                staticClass: "ap-button-edit-category-svg"
              }),
              _vm._v(" "),
              _vm.getCategoryByIds(_vm.categories).name
                ? _c("div", { staticClass: "ap-button-edit-category-text" }, [
                    _vm._v(_vm._s(_vm.getCategoryByIds(_vm.categories).name))
                  ])
                : _c("div", { staticClass: "ap-button-edit-category-text" }, [
                    _vm._v("Категория не выбрана")
                  ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showAlert === "categories",
                  expression: "showAlert === 'categories'"
                }
              ],
              staticClass: "ap-modal-element"
            },
            [
              _c("div", { staticClass: "form-alert-danger" }, [
                _vm._v(
                  "\n                        Обязательное поле!\n                    "
                )
              ])
            ]
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          [
            _c("div", { staticClass: "ap-modal-element" }, [
              _c("div", { staticClass: "ap-modal-input-name" }, [
                _vm._v(
                  "\n                        Стоимость, ₽\n                    "
                )
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.price,
                    expression: "price"
                  }
                ],
                staticClass: "cd-modal-text-input",
                attrs: { type: "text" },
                domProps: { value: _vm.price },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.price = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showAlert === "price",
                      expression: "showAlert === 'price'"
                    }
                  ],
                  staticClass: "form-alert-danger"
                },
                [
                  _vm._v(
                    "\n                        Обязательное поле!\n                    "
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ap-modal-element" }, [
              _c("div", { staticClass: "modal-checkbox-grid" }, [
                _c("div", { staticClass: "pretty p-default modal-checkbox" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.active,
                        expression: "active"
                      }
                    ],
                    staticClass: "cd-modal-text-input",
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.active)
                        ? _vm._i(_vm.active, null) > -1
                        : _vm.active
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.active,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.active = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.active = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.active = $$c
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "state p-danger" }, [_c("label")])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-checkbox-text" }, [
                  _vm._v(
                    "\n                            Доступен в конфигураторе\n                        "
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.type === "wall",
                    expression: "type === 'wall'"
                  }
                ]
              },
              [
                _c("div", { staticClass: "ap-modal-title-medium" }, [
                  _vm._v(
                    "\n                        Изображение текстуры\n                    "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.srcTextureImg,
                        expression: "srcTextureImg"
                      }
                    ],
                    staticClass: "ap-change-photo-anchor"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "ap-change-photo-btn",
                        on: {
                          click: function($event) {
                            return _vm.$refs.loadTextureImg.click()
                          }
                        }
                      },
                      [_c("SVGAdminEditRow", {})],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.srcTextureImg
                  ? _c("img", {
                      staticClass: "ap-product-modal-img",
                      attrs: {
                        alt: "texture",
                        src: _vm.urlForPhoto(_vm.srcTextureImg)
                      }
                    })
                  : _c("SVGApLoadProductImg", {
                      staticClass: "ap-product-modal-img pointer",
                      nativeOn: {
                        click: function($event) {
                          return _vm.$refs.loadTextureImg.click()
                        }
                      }
                    }),
                _vm._v(" "),
                _c("input", {
                  ref: "loadTextureImg",
                  attrs: { hidden: "", type: "file", accept: ".jpg,.png" },
                  on: {
                    change: function($event) {
                      return _vm.handleFileUpload(
                        $event,
                        _vm.callbackLoadedTextureImg
                      )
                    }
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "ap-modal-title-medium" }, [
              _vm._v("\n                    Миниатюра\n                ")
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.srcPreviewImg,
                    expression: "srcPreviewImg"
                  }
                ],
                staticClass: "ap-change-photo-anchor"
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "ap-change-photo-btn",
                    on: {
                      click: function($event) {
                        return _vm.$refs.loadPrevImg.click()
                      }
                    }
                  },
                  [_c("SVGAdminEditRow", {})],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _vm.srcPreviewImg
              ? _c("img", {
                  staticClass: "ap-product-modal-img",
                  attrs: {
                    alt: "texture",
                    src: _vm.urlForPhoto(_vm.srcPreviewImg)
                  }
                })
              : _c("SVGApLoadProductImg", {
                  staticClass: "ap-product-modal-img pointer",
                  nativeOn: {
                    click: function($event) {
                      return _vm.$refs.loadPrevImg.click()
                    }
                  }
                }),
            _vm._v(" "),
            _c("input", {
              ref: "loadPrevImg",
              attrs: { hidden: "", type: "file", accept: ".jpg,.png" },
              on: {
                change: function($event) {
                  return _vm.handleFileUpload(
                    $event,
                    _vm.callbackLoadedPreviewImg
                  )
                }
              }
            })
          ],
          1
        )
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "modal-button", on: { click: _vm.apply } }, [
      _vm._v("\n            " + _vm._s(_vm.buttonName) + "\n        ")
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }